import { useEffect, useMemo } from "react";
import { useLazyQuery } from "@apollo/client";
import { GET_PROMOS } from "./queries/promos";

export const usePromosByIds = (hotelRef, promoIds = []) => {
    const [runByIds, { data: dataByIds }] = useLazyQuery(GET_PROMOS.query, {
        fetchPolicy: "cache-and-network",
        errorPolicy: "all",
    });

    const canRunByIds = !!hotelRef && Array.isArray(promoIds) && promoIds.length > 0;

    const variablesByIds = useMemo(
        () => ({ hotelRef, filter: { ids: promoIds } }),
        [hotelRef, JSON.stringify(promoIds)]
    );

    useEffect(() => {
        if (canRunByIds) runByIds({ variables: variablesByIds });
    }, [canRunByIds, runByIds, variablesByIds]);

    const [runDefault, { data: dataDefault }] = useLazyQuery(GET_PROMOS.query, {
        fetchPolicy: "cache-and-network",
        errorPolicy: "all",
    });

    const canRunDefault = !!hotelRef;

    const variablesDefault = useMemo(() => ({ hotelRef, filter: { isDefault: true } }), [hotelRef]);

    useEffect(() => {
        if (canRunDefault) runDefault({ variables: variablesDefault });
    }, [canRunDefault, runDefault, variablesDefault]);

    return {
        promosByIds: dataByIds?.getPromos?.results ?? [],
        promosDefault: dataDefault?.getPromos?.results ?? [],
    };
};
